/**
 * useUserProfile Hook
 *
 * Provides user profile data and actions
 */
import { useAuthStore } from '@/store';
import type { UserProfile } from '../types';

export const useUserProfile = () => {
  const { user } = useAuthStore();

  // User from authStore is already in the correct format
  const userProfile: UserProfile | null = user;

  return {
    user: userProfile,
    isLoading: false,
  };
};
